export const DEFAULT_TILE_HEIGHT_WIDTH = 80;
export const DEFAULT_TILES_PER_ROW = 4;
const TILE_HEIGHT_WITH_PADDING = 88;
export const getHeightForRenderedTilesSection = ({
  numberOfTiles,
  offset = 0,
  tileHeight = TILE_HEIGHT_WITH_PADDING,
  tilesPerRow = DEFAULT_TILES_PER_ROW
}) => {
  const numberOfRows = Math.ceil(numberOfTiles / tilesPerRow);
  return numberOfRows * tileHeight + offset;
};